import React, { useState, useEffect } from "react";
import {
  BackgroundLayout,
  ItemField,
  ItemText,
  PageLayout,
  RowLayout,
  TitleText,
} from "../component";
import { axiosInstance } from "../axiosConfig";

const UserScreen = () => {
  const [userId, setUserId] = useState("");
  const [name, setName] = useState("");
  const [role, setRole] = useState("");

  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_BASE_URL}/user/info`, {
        headers: {
          Authorization: `${localStorage.getItem("accessToken")}`,
        },
      })
      .then((res) => {
        setUserId(res.data.id);
        setName(res.data.name);
        setRole(res.data.role);
      });
  }, []);

  return (
    <PageLayout
      style={{
        justifyContent: "flex-start",
        alignItems: "start",
        flexDirection: "column",
      }}
    >
      <TitleText>내 정보</TitleText>
      <BackgroundLayout
        style={{
          width: "50%",
          justifyContent: "flex-start",
          flexDirection: "column",
          marginTop: "20px",
        }}
      >
        <RowLayout>
          <ItemText> 아이디 </ItemText>
          <ItemField> {userId} </ItemField>
        </RowLayout>
        <RowLayout>
          <ItemText> 이름 </ItemText>
          <ItemField> {name} </ItemField>
        </RowLayout>
        <RowLayout>
          <ItemText> 권한 </ItemText>
          <ItemField> {role} </ItemField>
        </RowLayout>
      </BackgroundLayout>
    </PageLayout>
  );
};

export default UserScreen;
